<template>
  <div v-if="loaded">
        <span @click="setToggleOptions" class="flex" id="show-reviews-popup" style="color: white">
                                        {{ navTitle }}:&nbsp;<span
            id="view-review-from-name">{{ onBehalfAccount.name }}</span>
                                        <span class="acclaro-icon ai-arrow-downwhite"></span>
                                    </span>
    <div v-if="showOptions" class="view-options">
      <div id="view-programs-from-inner">
        <div id="behalf_account_select_parent">
          <v-select :options="accountList"
                    placeholder="Select Account"
                    class="v-select-styling"
                    @input="onAccountSelect"
                    label="name"
                    :value="onBehalfAccount">
          </v-select>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import "vue-select/dist/vue-select.css";
import './style.scss';
import {mapState, mapMutations, mapActions} from 'vuex';


export default {
  name: "OnBehalf",
  props: [
    'navTitle',
    'accountDataUrl'
  ],
  mounted () {
    this.loadAccountData(this.accountDataUrl);
    
    console.log('loaded');
  },
  computed: {
    ...mapState('TRMOnBehalfStore', [
      'loaded',
      'onBehalfAccount',
      'accountList',
      'showOptions',
      'toggleOptions',
    ])
  },
  methods: {
    ...mapActions('TRMOnBehalfStore', [
      'loadAccountData',
    ]),
    ...mapMutations('TRMOnBehalfStore',
        ['onAccountSelect',
          'setShowOptions',
          'setLoaded',
          'setToggleOptions',
          'setAccountList',
          'setOnBehalfAccount']),
    onAccountSelect (val) {
      this.setOnBehalfAccount(val);
      this.setShowOptions(false);
    },

  }
};
</script>
